export default "__VITE_ASSET__C91hg5NI__"